import { mergeSx } from "@/utils/styleHelpers";
import { useMemo } from "react";

import { SvgIcon, type SvgIconProps } from "@/components/SvgIcon";
import {
  BUTTON_SIZES,
  DEFAULT_BUTTON_SIZE,
  DEFAULT_BUTTON_VARIANT,
} from "@/constants";
import { useTheme } from "@/hooks";
import type { ButtonSize, ButtonVariant, MakeResponsive } from "@/types";
import { getStartingSize } from "@/utils/styleHelpers";

import { getButtConIconStyles, getResponsiveButtConIconStyles } from "./styles";

export type ButtonIconProps = SvgIconProps & {
  size?: MakeResponsive<ButtonSize>;
  variant?: ButtonVariant;
};

export function ButtConSvgIcon({
  size = DEFAULT_BUTTON_SIZE,
  variant = DEFAULT_BUTTON_VARIANT,
  domRef,
  children,
  sx,
  ...props
}: ButtonIconProps) {
  const themeProps = useTheme();
  const startingSize = getStartingSize(size, DEFAULT_BUTTON_SIZE, BUTTON_SIZES);
  const mergedSx = useMemo(
    () =>
      mergeSx(
        getButtConIconStyles({
          size: startingSize,
          variant,
          themeProps,
        }),
        getResponsiveButtConIconStyles({
          variant,
          size,
          themeProps,
        }),
        sx,
      ),
    [variant, size, themeProps, sx, startingSize],
  );

  return (
    <SvgIcon {...props} sx={mergedSx}>
      {children}
    </SvgIcon>
  );
}

ButtConSvgIcon.displayName = "ButtCon.SvgIcon";
